import { ErrorTracker } from '@g2-shared/common';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';

const { VITE_APP_SUB_DIR } = import.meta.env;

ErrorTracker();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter basename={VITE_APP_SUB_DIR}>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
